<template>
  <div class="profile-flyout-personal-data-fi">
    <div class="profile-flyout-personal-data-fi__content">
      <div class="profile-flyout-personal-data-fi__welcoming">
        {{ sitecoreData.Headline.replace('{0}', customerProfile.fullName) }}
      </div>
      <template v-if="!hideCompanyAndCustomerNumber">
        <div class="profile-flyout-personal-data-fi__company">
          <span
            v-if="customerProfile.company?.name"
            class="profile-flyout-personal-data-fi__company__item"
          >
            {{ customerProfile.company.name }}
          </span>
          <span
            v-if="customerProfile.company?.sapCustomerId"
            class="profile-flyout-personal-data-fi__company__item"
          >
            {{
              sitecoreData.PersonalDataLabelCustomerNo?.replace(
                '{0}',
                customerProfile.company.sapCustomerId,
              ) || customerProfile.company.sapCustomerId
            }}
          </span>
        </div>
      </template>
    </div>
    <a
      v-if="sitecoreData.AccountManagementLink"
      class="profile-flyout-personal-data-fi__link"
      :href="sitecoreData.AccountManagementLink.Url"
    >
      {{ sitecoreData.AccountManagementLink.Text }}
      <icon-fi icon="edit" />
    </a>
  </div>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';
import { computed } from 'vue';

import type { ProfileFlyoutData } from '../profile-flyout-types';

defineOptions({ name: 'ProfileFlyoutPersonalDataFi' });

const props = defineProps<{
  sitecoreData: ProfileFlyoutData;
  customerProfile: Record<string, any>;
}>();

const hideCompanyAndCustomerNumber = computed(
  () => props.customerProfile?.company?.sapCustomerId === 'defaultB2BUnit',
);
</script>

<style scoped src="./profile-flyout-personal-data-fi" />
